import { render, staticRenderFns } from "./VAppSidebarNavigationLink.vue?vue&type=template&id=19e4e206&"
import script from "./VAppSidebarNavigationLink.vue?vue&type=script&lang=ts&"
export * from "./VAppSidebarNavigationLink.vue?vue&type=script&lang=ts&"
import style0 from "./VAppSidebarNavigationLink.vue?vue&type=style&index=0&id=19e4e206&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports